import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, Input, OnInit, output, TemplateRef, viewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialog, MatDialogActions, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { ButtonActivity, Charity, CharityScreeningVersion, PageActivity, Screening, SplitScreen, SplitScreenVersion } from '@domains';
import {
  FxFlexDirective,
  FxLayoutAlignDirective,
  FxLayoutDirective,
  FxLayoutGapDirective,
  SplitScreenV3aComponent,
  SplitScreenV3bComponent,
  SplitScreenV4Component,
} from '@rspl-ui';
import { take } from 'rxjs/operators';

import { AppService } from '../../app.service';
import { DonorScreeningComponent } from '../donor-screening/donor-screening.component';

@Component({
  selector: 'app-split-screen',
  templateUrl: './split-screen.component.html',
  styleUrls: ['./split-screen.component.scss'],
  imports: [
    FxLayoutDirective,
    FxFlexDirective,
    MatIcon,
    FxLayoutGapDirective,
    FxLayoutAlignDirective,
    MatButton,
    NgClass,
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatDialogActions,
    DonorScreeningComponent,
    NgTemplateOutlet,
    SplitScreenV3aComponent,
    SplitScreenV3bComponent,
    SplitScreenV4Component,
  ],
})
export class SplitScreenComponent implements OnInit {
  #charity!: Charity;
  config: SplitScreen;
  @Input() set charity(charity: Charity) {
    this.#charity = charity;
    if (this.charity && !new URLSearchParams(window.location.search).get('isPreview')) {
      this.service.createLeadActivity(this.leadId, PageActivity.SPLIT_LANDING_PAGE, this.charity.meta?.version).pipe(take(1)).subscribe();
    }
  }
  get charity(): Charity {
    return this.#charity;
  }

  @Input() leadId?: string;
  readonly close = output<{ stairs: any; disassembly: any }>();
  readonly restrictedItemsTemplate = viewChild.required<TemplateRef<any>>('RestrictedItems');
  restrictedItemsDialog: any;

  public isDesktop = true;

  splitScreenVersions = SplitScreenVersion;

  @Input() screening?: Screening | null;

  showScreening = false;

  constructor(
    private service: AppService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.isDesktop = window.innerWidth > 960;
    window.addEventListener('message', this.onMessage.bind(this));
    this.sendMessageToParent();
  }

  onMessage(event: MessageEvent) {
    if (event?.data?.splitscreenConfig) {
      this.config = event.data.splitscreenConfig;
    }
  }

  sendMessageToParent() {
    window.parent.postMessage({ splitscreenConfig: { loaded: true } }, '*');
  }

  get textValues(): string[] {
    return (this.charity.meta?.text?.trim().length || 0) > 0 ? this.charity.meta?.text?.trim().split('\n') || [] : [];
  }

  get textValue(): string | undefined {
    return (this.charity.meta?.text?.trim().length || 0) > 0 ? this.charity.meta?.text?.trim().replaceAll('\n', '<br/>') : undefined;
  }

  get textPrimaryValues(): string[] {
    return this.charity.meta?.textPrimary?.split('\n') || [];
  }

  get textPrimaryValue(): string | undefined {
    return this.charity.meta?.textPrimary?.replaceAll('\n', '<br/>') || undefined;
  }

  goToPrimary(section?: string | undefined): void {
    this.service
      .createLeadActivity(this.leadId, ButtonActivity.PRIORITY_OPTION_CLICKED, section)
      .pipe(take(1))
      .subscribe(() => this.close.emit(undefined));
  }

  goToFree(): void {
    this.service
      .createLeadActivity(this.leadId, ButtonActivity.FREE_OPTION_CLICKED)
      .pipe(take(1))
      .subscribe(() => {
        if (this.charity.meta?.screening === CharityScreeningVersion.V1 && this.screening) {
          this.showScreening = true;
        } else if (this.charity.meta?.url) {
          window.location.href = this.charity.meta?.url;
        }
      });
  }

  showRestrictedItems() {
    this.restrictedItemsDialog = this.dialog.open(this.restrictedItemsTemplate());
  }
}
